import React, { useState, useEffect } from 'react';
import { Play } from 'lucide-react';
import { PrimaryButton } from './ui';
import type { Clip } from '@/types';

interface CoinFlipProps {
  hisName: string;
  herName: string;
  hisPick: Clip;
  herPick: Clip;
  onResult: (clip: Clip) => void;
  onClose: () => void;
}

export const CoinFlip: React.FC<CoinFlipProps> = ({
  hisName,
  herName,
  hisPick,
  herPick,
  onResult,
  onClose
}) => {
  const [spinning, setSpinning] = useState(true);
  const [winner, setWinner] = useState<'his' | 'her' | null>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      const result = Math.random() < 0.5 ? 'his' : 'her';
      setWinner(result);
      setSpinning(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4">
      <div className="bg-zinc-800 rounded-2xl p-8 w-full max-w-md border border-zinc-700 text-center">
        <h2 className="text-2xl font-bold text-white mb-6">Coin Flip!</h2>

        <div className="mb-6">
          <div className={`w-32 h-32 mx-auto rounded-full bg-gradient-to-br from-amber-400 to-yellow-600 flex items-center justify-center text-6xl shadow-2xl ${spinning ? 'animate-spin' : ''}`}>
            {spinning ? '🪙' : winner === 'his' ? '👨' : '👩'}
          </div>
        </div>

        {!spinning && winner && (
          <div className="space-y-4">
            <div className="bg-gradient-to-r from-pink-500/20 to-purple-500/20 border border-pink-500/30 rounded-xl p-4">
              <p className="text-2xl font-bold text-white">
                {winner === 'his' ? `${hisName} Wins!` : `${herName} Wins!`}
              </p>
              <p className="text-zinc-400 mt-2">
                Tonight's choice: <span className="text-white font-semibold">
                  {winner === 'his' ? hisPick.title : herPick.title}
                </span>
              </p>
            </div>

            <PrimaryButton
              onClick={() => onResult(winner === 'his' ? hisPick : herPick)}
              className="w-full"
            >
              <Play className="w-5 h-5" /> Let's Go!
            </PrimaryButton>

            <button onClick={onClose} className="text-zinc-400 hover:text-white text-sm">
              Cancel
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
